import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { HistorieFilterPopoverPage } from './historie-filter-popover.page';

const routes: Routes = [
  {
    path: '',
    component: HistorieFilterPopoverPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [HistorieFilterPopoverPage]
})
export class HistorieFilterPopoverPageModule {}
